/** Consecutive failed password attempts allowed before an account is locked out. */
export const maxPasswordAttempts = 5;

export const validatePassword = (password: string): boolean => {
  const minLength = !!password && password.length >= 8;
  const longEnough = !!password && password.length >= 16;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);

  return longEnough || (minLength && hasUppercase && hasLowercase && hasNumber && hasSpecial);
};
